// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__zBheF","header":"ReportDetails_header__1SJYL","title":"ReportDetails_title__34O2J","left":"ReportDetails_left__2Oh0n"};